<template>
	<div class="page">
		<Breadcrumb :pathList='pathList'></Breadcrumb>
		<div class="content">
			<div class="flex-only" style="margin-top: 20px;">
				<img :src="detail.img" style="width: 284px;height: 161px;border-radius: 13px;" />
				<div class="right flex-1">
					<div class="name">{{detail.name}}</div>
					<div class="xy">{{$route.query.course_cate_name}}</div>
				</div>
			</div>
			<div class="titles">购买章节</div>
			<div class="gbox">
				<div class="flex-only botl" v-if="buyAll==0" v-for="(item,index) in buyChapters">
					<div class="num">第{{index+1}}章</div>
					<div class="flex-1">
						<div class="flex flex-b">
							<div class="name">{{item.name}}</div>
							<div class="score">
								{{item.score-parseInt(loginUser.member?loginUser.member.discount:0)}}<span>积分</span>
							</div>
							<!-- <div class="score">{{item.score}}<span>积分</span></div> -->
						</div>
						<div class="flex flex-b">
							<div class="long" v-if="item.type==1">
								{{parseFloat(item.file.second/60).toFixed(1)<=1?parseFloat(item.file.second)+'秒':parseFloat(item.file.second/60).toFixed(1)+'分钟'}}/视频
							</div>
							<div class="long" v-if="item.type==2">
								{{parseFloat(item.file.second/60).toFixed(1)<=1?parseFloat(item.file.second)+'秒':parseFloat(item.file.second/60).toFixed(1)+'分钟'}}/音频
							</div>
							<div class="long" v-if="item.type==3">PDF</div>
							<div class="long" v-if="item.type==4">PPT</div>
							<div class="linePrice">{{item.score}}积分</div>
						</div>
					</div>
				</div>
				<div class="flex-only flex-b" v-if="buyAll==1">
					<div class="all">整课购买</div>
					<div>
						<div class="score">{{detail.score}}<span>积分</span></div>
						<div class="score">
							{{detail.score-parseInt(loginUser.member?loginUser.member.discount:0)>0?detail.score-parseInt(loginUser.member?loginUser.member.discount:0)*(buyAll==1?detail.chapter.length:buyChapters.length):0}}<span>积分</span>
						</div>
						<!-- <div class="linePrice t-r">{{detail.score}}积分</div> -->
					</div>
				</div>
			</div>
			<div class="wbox">
				<div class="tit">会员优惠</div>
				<div class="flex flex-b">
					<div class="flex mt10">
						<img src="../../assets/images/course/hgImg.png" style="width: 27px;height: 27px;" alt="" />
						<div class="vipName">{{loginUser.member?loginUser.member.name:''}}</div>
					</div>
					<div class="score2">-{{loginUser.member?loginUser.member.discount:0}}<span>积分/章节</span></div>
				</div>
			</div>
			<div class="wbox">
				<div class="tit">购买合计</div>
				<div class="flex flex-b mt10">
					<div class="t">合计原价</div>
					<div class="score3" v-if="buyAll==1">{{detail.score}}<span>积分</span></div>
					<div class="score3" v-if="buyAll==0">
						{{buyAllOriChapterScore>0?buyAllOriChapterScore:0}}<span>积分</span>
					</div>
				</div>
				<div class="flex flex-b mt10">
					<div class="t">合计会员折扣</div>
					<div class="score2">
						-{{loginUser.member?loginUser.member.discount*(buyAll==1?detail.chapter.length:buyChapters.length):0}}<span>积分/章节</span>
					</div>
				</div>
				<div class="flex flex-b" style="border-top: 1px solid #EEEEEE;padding-top: 10px;margin-top: 10px;">
					<div class="t" style="font-weight: 600;">实付积分</div>
					<div class="score4" v-if="buyAll==1">
						{{detail.score-parseInt(loginUser.member?loginUser.member.discount:0)>0?detail.score-parseInt(loginUser.member?loginUser.member.discount:0)*(buyAll==1?detail.chapter.length:buyChapters.length):0}}<span>积分</span>
						<!-- {{detail.score}}<span>积分</span> -->
					</div>
					<div class="score4" v-if="buyAll == 0">{{buyAllChapterScore>0?buyAllChapterScore:0}}<span>积分</span>
					</div>
				</div>
			</div>
			<div class="flex" style="margin-top: 60px;">
				<img src="../../assets/icon/wxz.png" v-if="!selectRule" @click="selectRule=!selectRule" class="pointer"
					style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
				<img src="../../assets/icon/xz.png" v-else @click="selectRule=!selectRule" class="pointer"
					style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
				<div class="tip">我已阅读并同意以下内容<span class="pointer">报名须知</span>以及<span class="pointer">合同条款</span></div>
			</div>
		</div>
		<div class="bottomFixed flex flex-b">
			<div>
				<div class="score4" v-if="buyAll==1">
					{{detail.score-parseInt(loginUser.member?loginUser.member.discount:0)>0?detail.score-parseInt(loginUser.member?loginUser.member.discount:0)*(buyAll==1?detail.chapter.length:buyChapters.length):0}}<span>积分</span>
				</div>
				<div class="score4" v-if="buyAll==0">{{buyAllChapterScore>0?buyAllChapterScore:0}}<span>积分</span></div>
				<div class="mt10 t1" v-if="buyAll==1">已选{{chapter.length}}个章节</div>
				<div class="mt10 t1" v-if="buyAll==0">已选{{buyChapters.length}}个章节</div>
			</div>
			<div class="login-btn pointer" @click="toBuyClick"><span class="text">立即购买</span></div>
		</div>

		<el-dialog :visible.sync="buySuccess" width="382" center :show-close="false">
			<div class="flex-column-item">
				<img src="../../assets/images/course/success.png" style="width: ;height: 53px;" alt="" />
				<div class="mt10" style="font-size: 16px;color: #666666;">
					已完成购买，本次共购买{{buyAll==1?chapter.length:buyChapters.length}}个章节</div>
			</div>
			<div class="flex flex-b">
				<div class="wxbtn pointer" style="width: 156px;height: 46px;"
					@click="buySuccess=false,$router.push('/allCourse')">我知道了</div>
				<div class="login-btn pointer" @click="$router.push('/myCourseDetail?id='+id+'&course_category_name='+detail.course_category_name)">
					<span class="text">前往学习</span>
				</div>
			</div>
		</el-dialog>

		<!-- <Toast ref="toastRef"></Toast> -->
	</div>
</template>

<script>
	import {
		getMyCourse,
		getUser,
		EditUser,
	} from '@/api/mine';
	import Utils from "@/jslibs/utils";
	import {
		getCourseDetail,
		addCollect,
		delCollect,
		getCourse,
		getCourseOrderEvaluate,
		buyCourseOrder
	} from "@/api/course";
	import Toast from '../../components/Toast.vue';
	import Breadcrumb from '../../components/Breadcrumb.vue'
	export default {
		data() {
			return {
				buySuccess: false,
				pathList: [{
						title: '课程列表',
						path: '/course'
					},
					{
						title: '课程详情',
						path: ''
					},
					{
						title: '课程购买',
						path: ''
					}
				],
				loginUser: {
					member: {}
				},
				detail: '',
				chapter: [],
				id: '',
				buyAll: 0,
				selectRule: false,
				buyChapters: [],
				buyAllChapterScore: 0,
				buyAllOriChapterScore: 0
			}
		},
		components: {
			Toast,
			Breadcrumb
		},
		mounted() {
			let that = this
			if (Utils.getCookie('loginUser')) {
				this.getUser()
			}
			this.id = this.$route.query.id
			this.getCourseDetail()
			this.pathList[1].path = '/courseDetail?id=' + this.id + '&course_cate_name=' + this.$route.query
				.course_cate_name
		},
		// mounted() {
		// 	this.$nextTick(() => {
		// 		this.$refs.toastRef.openToast('课程已下架')
		// 		// this.$refs.toastRef.openToast('账户余额不足')
		// 		// this.$refs.toastRef.openToast('交易状态异常，请重新发起订单')
		// 	})
		// },
		methods: {
			async getUser() {
				const {
					status,
					data
				} = await getUser({})
				this.loginUser = {
					...data.result
				}
				this.buyAll = this.$route.query.buyAll
				if (this.buyAll == 0) {
					this.buyChapters = JSON.parse(Utils.getCookie("buyChapters"))
					let scores = []
					this.buyChapters.forEach(_item => {
						scores.push(parseInt(_item.score))
					})
					if (scores.length > 0) {
						this.buyAllChapterScore = scores.reduce((a, b) => a + b) - parseInt(this.loginUser.member ?
							this
							.loginUser
							.member.discount : 0) * scores.length
						// this.buyAllChapterScore = scores.reduce((a, b) => a + b)
						this.buyAllOriChapterScore = scores.reduce((a, b) => a + b)
					}
				}
			},
			async toBuyClick() {
				if (!this.selectRule) {
					this.$message({
						message: "请阅读并同意以下内容《报名须知》以及《合同条款》",
						type: "warning"
					});
					return
				}
				const buyParams = {
					type: 1,
				}
				if (this.buyAll == 1) {
					let arrs = this.chapter.map(item => item.uuid)
					buyParams.chapter_uuid = arrs
				} else {
					let arrs = this.buyChapters.map(item => item.uuid)
					buyParams.chapter_uuid = arrs
				}
				const {
					status,
					data
				} = await buyCourseOrder({
					type: 1,
					...buyParams
				});
				if (data.result) {
					this.buySuccess = true
				}
			},
			async getCourseDetail() {
				const {
					status,
					data
				} = await getCourseDetail({
					uuid: this.id,
				});
				this.detail = data.result
				this.chapter = this.detail.chapter
			},
			goBack() {
				this.$router.go(-1)
			},
			toPage(path) {
				this.$router.push({
					path: path
				})
			},
		},
	}
</script>

<style lang="less" scoped>
	.login-btn {
		width: 160px;
		height: 52px;
		background: url('../../assets/images/course/btnw164.png') no-repeat;
		background-size: 100% 100%;
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: center;

		.text {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
			text-align: center;
			font-style: normal;
			text-transform: none;
			background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}

	.wxbtn {
		margin-top: 20px;
		width: 360px;
		height: 51px;
		border-radius: 12px 12px 12px 12px;
		border: 2px solid rgba(127, 218, 76, .24);
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400;
		font-size: 16px;
		text-align: center;
		font-style: normal;
		text-transform: none;
		background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.page {
		padding: 30px 133px 120px;

		.content {
			margin: 30px 233px 0;
			border-top: 4px solid rgba(0, 167, 60, 0.24);

			.right {
				margin-left: 20px;

				.name {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 27px;
					color: #000000;
				}

				.xy {
					margin-top: 10px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #999999;
				}
			}

			.gbox {
				background: #FAFBFC;
				border-radius: 13px 13px 13px 13px;
				padding: 16px 20px;

				.all {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
				}
			}

			.botl {
				padding: 0 0 12px;
				margin-bottom: 10px;
				border-bottom: 1px solid #EEEEEE;

				&:last-child {
					border-bottom: none;
					margin-bottom: 0;
					padding-bottom: 0;
				}
			}

			.num {
				padding-top: 5px;
				margin-right: 20px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #999999;
			}

			.name {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #333333;
			}

			.long {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #666666;
			}

			.wbox {
				background: #FFFFFF;
				box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
				border-radius: 13px 13px 13px 13px;
				padding: 20px;
				margin: 20px 0;

				.tit {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 500;
					font-size: 18px;
					color: #333333;

				}

				.vipName {
					margin-left: 6px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #D7B155;
				}

				.score2 {
					font-family: DINPro, DINPro;
					font-weight: 500;
					font-size: 18px;
					color: #D7B155;

					span {
						margin-left: 6px;
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 400;
						font-size: 13px;
						color: #D7B155;
					}
				}

				.score3 {
					font-family: DINPro, DINPro;
					font-weight: 500;
					font-size: 18px;
					color: #333333;

					span {
						margin-left: 6px;
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 400;
						font-size: 13px;
						color: #333333;
					}
				}

				.t {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
				}
			}

			.tip {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #999999;

				span {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 500;
					font-size: 13px;
					color: #00A73C;
				}
			}
		}

		.mt10 {
			margin-top: 10px;
		}

		.score4 {
			font-family: DINPro, DINPro;
			font-weight: bold;
			font-size: 22px;
			color: #00A73C;

			span {
				margin-left: 6px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #00A73C;
			}
		}

		.bottomFixed {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			background: #FFFFFF;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			padding: 20px 356px;
			z-index: 999;

			.t1 {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #000000;
			}

			.login-btn {
				width: 276px;
				height: 50px;
				background: url('../../assets/images/login/loginbtn.png') no-repeat;
				background-size: 100% 100%;
				margin-top: 13px;
				display: flex;
				align-items: center;
				justify-content: center;

				.text {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 16px;
					text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
					text-align: center;
					font-style: normal;
					text-transform: none;
					background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				}
			}
		}
	}
</style>